import { logger } from "../../js";

export const onChangeHandler = (value:any,onChange:Function, localStateSetter ?:Function | undefined, externalStateSetter ?:Function | undefined) => {
  logger.log("ONChangeHandler - Value",value)
  onChange(value);
  localStateSetter && localStateSetter(value.target.value)
  externalStateSetter && externalStateSetter(value.target.value)
}